<template>
<div>
<ContentHeader title="Yeni Video"  url="EducationpackVideos" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>

<form @submit.prevent="submit" >


<FileUpload name="video_files[]"  @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosyaları Seçin"    :maxFileSize="10000000000" class="">
  <template #empty>
    
    <div class="uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>Dosyaları buraya sürükleyip bırakın</p>
    </div>
      
  </template>
</FileUpload>
<ProgressBar v-if="$store.state.ui.upload_progress>0" :value="$store.state.ui.upload_progress" class="mt-2 mb-2"/>

<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>

</div>
</template>

<script>
import nanoMetadata from 'nano-metadata'
export default {

  name: 'CreateEducationpackVideo',

  data () {
    return {
    	files:[],
    }
  },
  methods:{
  	 onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
    async getVideoMeta(index)
    {
      let file =  await this.files[index]
      let fileduration 
      await nanoMetadata.video.duration(file).then((duration) => {
        console.log("nanoMetadata")
        console.log(duration)
        fileduration = duration
      })

       return await fileduration
    },
    async submit()
    {         
      let formdata = new FormData()
      //formdata.append('cover_image', this.files);

      for( var i = 0; i < this.files.length; i++ ){
        let file =  await this.files[i];
        await formdata.append('video_files[' + i + ']', file);
      }
      let durations = await []
      for( var i = 0; i < this.files.length; i++ ){

        let duration = await this.getVideoMeta(i)
        await durations.push(Math.floor(duration))
      }

      await formdata.append("durations",JSON.stringify(durations))



      
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmissionWithProgress(formdata,"educationpack/upload_video/"+this.$route.params.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response.data)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        }   
        this.$router.push({ name: 'EducationpackVideos'})  
      
    },
  }
}
</script>

<style lang="css" scoped>
</style>